import { gql, useQuery } from "@apollo/client";
import React from "react";
import styled from "styled-components";
import { Loading } from "../Loading";
import { useLocation } from "react-router";
import NotMatch from "../../Pages/NotMatch";
import ResumeDataShow from "./ResumeDataShow";

const Style = styled.div`
    direction: ltr;
    display: flex;
    flex-direction: column;
    position: relative;
    padding: 90px 1rem 1rem;
`;
const Resume_Query = gql`
    query ResumeQuery($User_ID: ID!){
        getResumeUser(User_ID: $User_ID){
            _id
            User
            Name
            Position
            Image
            Email
            Mobile
            Province
            Address
            Maried
            BirthYear
            Gender
            Military
            Job
            Description
            DescriptionJob
            image
            JobBack {
                JobTitle
                companyName
                InDate
                OutDate
                Working
            }
            EduBack {
                EduTitle
                Where
                EduName
                InDate
                OutDate
            }
            LanBack {
                LanTitle
                Level
            }
        }
    }
`

export default function Profile({pageHeight, data, language}) {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const resume = useQuery(Resume_Query, {
        variables: {
            User_ID: params.get("USER")
        }
    });
    if(resume.loading){
        return (
            <div style={{marginTop: "120px"}}>
              <Loading/>
            </div>
        )
    }
    if(!resume.data.getResumeUser.Name){
        return (
            <NotMatch key={0}/>
        )
    }
    let dataResume = resume.data.getResumeUser;

    return (
      <Style>
        <ResumeDataShow resume={dataResume}/>
      </Style>
  );
}
